import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-[#3D4852] text-gray-400 py-8 text-center text-sm border-t border-white/10" data-id="element-42">
        <div className="container mx-auto px-4" data-id="element-43">
          <p className="mb-4" data-id="element-44">
            &copy; {new Date().getFullYear()} Menopausia Sin Barriga. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-45">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-46">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-47">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-48">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-49">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-50">
              <h2 className="text-xl font-bold text-[#3D4852]" data-id="element-51">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={closeModal} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" data-id="element-52">
                <X className="w-5 h-5 text-gray-600" data-id="element-53" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(85vh-80px)] text-gray-600 text-sm leading-relaxed" data-id="element-54">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-55" /> : <TermsContent data-id="element-56" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <div className="space-y-6" data-id="element-57">
      <section data-id="element-58">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-59">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-60">
          Recopilamos información personal que nos proporcionas voluntariamente
          al realizar una compra, incluyendo tu nombre y dirección de correo
          electrónico para enviarte el producto digital adquirido.
        </p>
      </section>

      <section data-id="element-61">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-62">
          2. Uso de la Información
        </h3>
        <p data-id="element-63">Utilizamos tu información personal para:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-64">
          <li data-id="element-65">Procesar y entregar tu compra</li>
          <li data-id="element-66">Enviarte el producto digital (PDF) a tu correo electrónico</li>
          <li data-id="element-67">Comunicarnos contigo sobre tu pedido si es necesario</li>
        </ul>
      </section>

      <section data-id="element-68">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-69">
          3. Protección de Datos
        </h3>
        <p data-id="element-70">
          Implementamos medidas de seguridad apropiadas para proteger tu
          información personal contra acceso no autorizado, alteración,
          divulgación o destrucción.
        </p>
      </section>

      <section data-id="element-71">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-72">
          4. No Compartimos tu Información
        </h3>
        <p data-id="element-73">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Esto no incluye terceros de confianza que nos ayudan a
          operar nuestro sitio web o procesar pagos, siempre que estas partes
          acuerden mantener esta información confidencial.
        </p>
      </section>

      <section data-id="element-74">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-75">5. Cookies</h3>
        <p data-id="element-76">
          Podemos utilizar cookies para mejorar tu experiencia en nuestro sitio.
          Puedes configurar tu navegador para rechazar cookies, aunque esto
          puede afectar algunas funcionalidades del sitio.
        </p>
      </section>

      <section data-id="element-77">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-78">
          6. Cambios a esta Política
        </h3>
        <p data-id="element-79">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Te notificaremos sobre cambios significativos
          publicando la nueva política en esta página.
        </p>
      </section>

      <p className="text-xs text-gray-400 pt-4 border-t border-gray-100" data-id="element-80">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6" data-id="element-81">
      <section data-id="element-82">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-83">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-84">
          Al acceder y realizar una compra en este sitio web, aceptas cumplir
          con estos términos y condiciones de uso. Si no estás de acuerdo con
          alguna parte de estos términos, no debes utilizar nuestro sitio ni
          adquirir nuestros productos.
        </p>
      </section>

      <section data-id="element-85">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-86">2. Producto Digital</h3>
        <p data-id="element-87">
          "Menopausia Sin Barriga: Protocolo 21 Días Anti-Inflamación" es un
          producto digital en formato PDF. Al completar tu compra, recibirás
          acceso inmediato al material a través del correo electrónico
          proporcionado.
        </p>
      </section>

      <section data-id="element-88">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-89">3. Uso del Producto</h3>
        <p data-id="element-90">
          El producto adquirido es para uso personal únicamente. Queda
          prohibido:
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-91">
          <li data-id="element-92">Redistribuir, revender o compartir el contenido</li>
          <li data-id="element-93">Modificar o crear obras derivadas del material</li>
          <li data-id="element-94">Utilizar el contenido con fines comerciales sin autorización</li>
        </ul>
      </section>

      <section data-id="element-95">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-96">
          4. Descargo de Responsabilidad Médica
        </h3>
        <p data-id="element-97">
          Este producto es material educativo e informativo y NO constituye
          consejo médico profesional. Los resultados pueden variar según cada
          persona. Antes de iniciar cualquier cambio en tu dieta o rutina de
          ejercicio, consulta con un profesional de la salud calificado.
        </p>
        <p className="mt-2" data-id="element-98">
          No nos hacemos responsables por cualquier daño o perjuicio que pueda
          resultar del uso de la información contenida en este producto.
        </p>
      </section>

      <section data-id="element-99">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-100">
          5. Política de Reembolso
        </h3>
        <p data-id="element-101">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. No ofrecemos reembolsos una vez que el
          producto ha sido entregado.
        </p>
      </section>

      <section data-id="element-102">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-103">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-104">
          Todo el contenido, incluyendo textos, gráficos, logotipos y material
          descargable, está protegido por derechos de autor y es propiedad
          exclusiva de Menopausia Sin Barriga.
        </p>
      </section>

      <section data-id="element-105">
        <h3 className="font-bold text-[#3D4852] mb-2" data-id="element-106">7. Modificaciones</h3>
        <p data-id="element-107">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación en el sitio web.
        </p>
      </section>

      <p className="text-xs text-gray-400 pt-4 border-t border-gray-100" data-id="element-108">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>
    </div>;
}